import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicTabwiseTable from "../../components/dynamicscreens/DynamicTabwiseTable";
import { withRouter } from "../../components/withRouter";
import { receivedOrderListJSON } from "../../DynamicFormsJson/Transaction/ReceivedOrderList";

import swal from "sweetalert";
import {
  noInternetMsg,
  serverMsg,
  acceptMsg,
  rejectMsg,
} from "../../config/messageconstant";
import {
  getReceivedOrderListNew,
  getReceivedBillHeaderById,
  getReceivedOrderListByDateUpdated,
} from "../../Slice/receivedOrderList.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import endpoint from "../../config/endpoints";
import { apiGet, apiPost } from "../../utils/api_service";
import ProductListDialogBox from "./ProductListDialogBox";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { Grid, Paper } from "@mui/material";
import FilterPopUp from "./FilterPopUp";
import dayjs from "dayjs";
import { ButtonCompo } from "../../components/Comman/Button";
import { WindowsFilled } from "@ant-design/icons";

class ReceivedOrderList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        pendingOrderList: [],
        orderBillForGeneratedList: [],
      },
      openDialogBox: false,
      productList: [],
      ids: "",
      comment: "",
      filterPopUpFlag: false,
      selectedIds: [],
      selectedRows: {},
      tabValue: 0,
      fromDate: dayjs(),
      toDate: dayjs(),
      tabList: [
        {
          label: "Pending Order List",
          allyProps: 0,
          showExcelDownload: false,
          columns: [
            {
              name: "index",
              title: "Sr. No.",
              width: "10%",
              align: "center",
              positionCenter: true,
              showInscreen: true,
            },
            {
              title: "Order No.",
              name: "orderNo",
              showInscreen: true,
              align: "center",
              canSearch: true,
              positionCenter: true,
            },
            {
              title: "Order Date",
              name: "orderDate",
              showInscreen: true,
              positionCenter: true,
              align: "center",
              canSearch: true,
            },
            {
              title: "Order Placed Time",
              name: "dayDiff",
              showInscreen: true,
              alignCenter: "center",
              canSearch: true,
            },
            {
              title: "SH Code",
              name: "fromOrderShCode",
              showInscreen: true,
              alignCenter: "center",
              canSearch: true,
            },
            {
              title: "Firm Name",
              name: "fromOrderOwnerName",
              showInscreen: true,
              align: "left",
              canSearch: true,
            },
            {
              title: "State Name",
              name: "fromOrderStateName",
              showInscreen: true,
              align: "left",
              canSearch: true,
            },
            {
              title: "Area Name",
              name: "fromOrderAreaNames",
              showInscreen: true,
              align: "left",
              canSearch: true,
            },
            {
              title: "Total Quantity",
              name: "totalQty",
              showInscreen: true,
              alignCenter: "right",
              positionCenter: false,
              canSearch: true,
            },
            {
              title: "CGST",
              name: "cgstAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "SGST",
              name: "sgstAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "IGST",
              name: "igstAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "Taxable Amt",
              name: "taxableAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "Total",
              name: "totalAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "Action",
              name: "action",
              alignCenter: "center",
              showInscreen: true,
            },
          ],
          isActionColActive: true,
          value: "pendingOrderList",
        },
        {
          label: "Order list for Generate Bill",
          allyProps: 1,
          showExcelDownload: false,
          columns: [
            {
              name: "index",
              title: "Sr. No.",
              width: "10%",
              align: "center",
              positionCenter: true,
              showInscreen: true,
            },
            {
              title: "Order No.",
              name: "orderNo",
              showInscreen: true,
              align: "center",
              positionCenter: true,
              canSearch: true,
            },
            {
              title: "Order Date",
              name: "orderDate",
              showInscreen: true,
              align: "center",
              positionCenter: true,
              canSearch: true,
            },
            {
              title: "Order Placed Time",
              name: "dayDiff",
              showInscreen: true,
              alignCenter: "center",
              canSearch: true,
            },
            {
              title: "SH Code",
              name: "fromOrderShCode",
              showInscreen: true,
              align: "center",
              positionCenter: true,
              canSearch: true,
            },
            {
              title: "Firm Name",
              name: "fromOrderOwnerName",
              showInscreen: true,
              alignCenter: "left",
              canSearch: true,
            },
            {
              title: "State Name",
              name: "fromOrderStateName",
              showInscreen: true,
              align: "left",
              canSearch: true,
            },
            {
              title: "Area Name",
              name: "fromOrderAreaNames",
              showInscreen: true,
              align: "left",
              canSearch: true,
            },
            {
              title: "Total Quantity",
              name: "totalQty",
              showInscreen: true,
              alignCenter: "right",
              canSearch: true,
            },
            {
              title: "CGST",
              name: "cgstAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "SGST",
              name: "sgstAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "IGST",
              name: "igstAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "Taxable Amt",
              name: "taxableAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            {
              title: "Total",
              name: "totalAmt",
              alignCenter: "right",
              showInscreen: true,
              canSearch: true,
            },
            // {
            //   title: "Status",
            //   name: "status",
            //   alignCenter: "center",
            //   showInscreen: true,
            // },

            {
              title: "Action",
              name: "action",
              alignCenter: "center",
              showInscreen: true,
              width: 120,
            },
          ],
          isActionColActive: true,
          value: "orderBillForGeneratedList",
        },
      ],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.receivedOrderBillList !== nextProps.receivedOrderBillList) {
      if (
        this.props.receivedOrderBillList?.receivedOrderBill !==
        nextProps.receivedOrderBillList?.receivedOrderBill &&
        Object.keys(nextProps.receivedOrderBillList?.receivedOrderBill)
          .length != 0
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            pendingOrderList:
              nextProps.receivedOrderBillList?.receivedOrderBill.pendingList,
            orderBillForGeneratedList:
              nextProps.receivedOrderBillList?.receivedOrderBill
                .billingOrderList,
          },
        });
      }
    }
  }

  getData = async () => {
    const { showLoador, showNotification, getReceivedOrderListNew } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getReceivedOrderListNew().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (
        localStorage.getItem("showFilterOnReceivedOrder") &&
        localStorage.getItem("showFilterOnReceivedOrder") != 1
      ) {
        this.getData();
      } else {
        this.getDataNew();
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  getDataNew = async () => {
    const { getReceivedOrderListByDateUpdated, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {

      const noOfDays = localStorage.getItem("daysForPrimaryOrderOnLoad");

      let fromDateWithDaysValidation = dayjs()
        .subtract(noOfDays && noOfDays !== null ? noOfDays : 7, "day")
        .format("DD-MM-YYYY");


      showLoador({ loador: true });
      await getReceivedOrderListByDateUpdated({
        fromDate: fromDateWithDaysValidation,
        toDate: dayjs().format("DD-MM-YYYY"),
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  openGenerateBillForm = (rowData) => {
    this.props.navigate(receivedOrderListJSON.formPath + "/" + rowData.id);
  };

  changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "comment") {
      this.setState({ comment: value });
    }
  };

  acceptOrder = () => {
    const { showLoador, showNotification } = this.props;
    const { ids, comment, fromDate, toDate } = this.state;

    swal({
      text: "Do you want to accept the order",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        if (navigator.onLine) {
          showLoador({ loador: true });
          await apiGet({
            url:
              endpoint.stockStakeholderOrderHeader +
              "/update-status?ids=" +
              ids +
              "&status=2" +
              "&remark=" +
              comment,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({ msg: acceptMsg });
              this.toggle();
              if (
                localStorage.getItem("showFilterOnReceivedOrder") &&
                localStorage.getItem("showFilterOnReceivedOrder") != 1
              ) {
                this.getData();
              } else {
                this.onSearch(fromDate, toDate);
              }
            } else {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        } else {
          showNotification({ msg: noInternetMsg, severity: "error" });
        }
      }
    });
  };

  rejectOrder = (row) => {
    const { showLoador, showNotification } = this.props;
    const { tabList, ids, comment, fromDate, toDate } = this.state;

    const selectedTab = tabList.find((tab) => tab.value === "pendingOrderList");

    const allyProps = selectedTab?.allyProps;

    let rowId = ids != "" ? ids : row.id;

    swal({
      text: "Do you want to reject the order",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        if (navigator.onLine) {
          showLoador({ loador: true });
          await apiGet({
            url:
              endpoint.stockStakeholderOrderHeader +
              "/update-status?ids=" +
              rowId +
              "&status=4&remark=" +
              comment,
          }).then(({ data, success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({ msg: rejectMsg });
              if (ids != "" && allyProps == 0) {
                this.toggle();
              }
              if (
                localStorage.getItem("showFilterOnReceivedOrder") &&
                localStorage.getItem("showFilterOnReceivedOrder") != 1
              ) {
                this.getData();
              } else {
                this.onSearch(fromDate, toDate);
              }
            } else {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        } else {
          showNotification({
            msg: noInternetMsg,
            severity: "error",
          });
        }
      }
    });
  };

  toggle = () => {
    this.setState({
      openDialogBox: !this.state.openDialogBox,
    });
  };

  handleCloses = () => {
    this.setState({
      filterPopUpFlag: false,
    });
  };

  openProductListView = async (rowData) => {
    const { showLoador, showNotification, getReceivedBillHeaderById } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getReceivedBillHeaderById({ billHeaderId: rowData.id }).then(
        ({ response, success, prodList }) => {
          console.log(response);
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            this.setState({
              ids: rowData.id,
              productList: prodList,
              comment: response.remark,
              openDialogBox: true,
            });
          }
        }
      );
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  rowEdit = (rowData) => {
    this.props.navigate(receivedOrderListJSON.formPathEdit + "/" + rowData.id);
  };

  rowPDF = (rowData) => {
    const { lang } = this.state;
    const { showLoador, showNotification } = this.props;
    localStorage.setItem("lang", lang);
    localStorage.setItem("myReceivedOrderPdfId", rowData.id);
    window.open("./receivedOrder-pdf", "_blank");
  };

  onOpenFilter = () => {
    this.setState({
      filterPopUpFlag: true,
    });
  };

  onSearch = (fromDate, toDate) => {
    const { getReceivedOrderListByDateUpdated, showLoador, showNotification } =
      this.props;

    this.setState({
      fromDate: fromDate,
      toDate: toDate,
    });

    if (navigator.onLine) {
      showLoador({ loador: true });
      getReceivedOrderListByDateUpdated({
        fromDate: fromDate.format("DD-MM-YYYY"),
        toDate: toDate.format("DD-MM-YYYY"),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.handleCloses();
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  handleSelectionChangeNew = (data) => {
    this.setState({
      selectedRows: {
        0: data.pendingOrderList || [],
        1: data.orderBillForGeneratedList || [],
      },
    });
  };

  handleAcceptReject = (select) => {
    const { showLoador, showNotification } = this.props;
    const { selectedRows, tabValue, fromDate, toDate } = this.state;

    const selectedIds = selectedRows[tabValue] || [];

    if (!selectedIds || selectedIds.length == 0) {
      showNotification({
        msg: "Please select at least one order",
        severity: "error",
      });
      return;
    }

    let status;
    let message;

    if (tabValue == 0) {
      if (select == 0) {
        status = 2;
        message = "Do you want to accept the order?";
      } else if (select == 1) {
        status = 4;
        message = "Do you want to reject the order?";
      }
    } else if (tabValue == 1) {
      if (select == 2) {
        status = 1;
        message = "Do you want to cancel the order?";
      } else if (select == 1) {
        status = 4;
        message = "Do you want to reject the order?";
      }
    }

    if (status === undefined) {
      showNotification({
        msg: "Invalid action for this tab",
        severity: "warning",
      });
      return;
    }

    const dataToSave = { orderIds: selectedIds, status };

    swal({
      text: message,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willConfirm) => {
      if (willConfirm) {
        if (!navigator.onLine) {
          showNotification({ msg: noInternetMsg, severity: "error" });
          return;
        }

        showLoador({ loador: true });
        await apiPost({
          url:
            endpoint.stockStakeholderOrderHeader +
            "/get-update-status?status=" +
            status,
          postBody: dataToSave,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            showNotification({
              msg:
                select === 0
                  ? acceptMsg
                  : select === 1
                    ? rejectMsg
                    : "Order cancelled",
            });

            if (
              localStorage.getItem("showFilterOnReceivedOrder") &&
              localStorage.getItem("showFilterOnReceivedOrder") != 1
            ) {
              this.getData();
            } else {
              this.onSearch(fromDate, toDate);
            }
            window.location.reload();

          } else {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    });
  };

  handleChangeNew = (newValue) => {
    this.setState({ tabValue: newValue });
  };

  render() {
    const {
      tabList,
      dynamicMasterData,
      openDialogBox,
      productList,
      comment,
      filterPopUpFlag,
      tabValue,
      selectedRows,
    } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            showFilterIcon={
              localStorage.getItem("showFilterOnReceivedOrder") &&
                localStorage.getItem("showFilterOnReceivedOrder") == 1
                ? true
                : false
            }
            screenTitle={receivedOrderListJSON.screenTitle}
            showAddButton={false}
            onOpenFilter={this.onOpenFilter}
          />
          <DynamicTabwiseTable
            isShowCheckBoxTable={true}
            onSelectionChange={this.handleSelectionChange}
            selection={(selectedRows[this.state.tabValue] || [])}
            onSelectionChangeAtMain={this.handleSelectionChangeNew}
            handleChangeNew={this.handleChangeNew}
            rowList={dynamicMasterData}
            searchList={receivedOrderListJSON.searchList}
            formPath={receivedOrderListJSON.formPath}
            screenTitle={""}
            rowDelete={this.rowDelete}
            rowStatus={this.changeStatus}
            showHeadDelete={false}
            showAddButton={false}
            filterDataExcel={true}
            onSave={this.onSave}
            apiBaseURL={receivedOrderListJSON.apiBaseURL}
            baseIdColumn={receivedOrderListJSON.baseIdColumn}
            tabList={tabList}
            getListById={this.getListById}
            showApply={true}
            showPdf={true}
            staticView={true}
            rowPDF={this.rowPDF}
            rowViewData={this.openProductListView}
            showView={true}
            viewConditionValue="1"
            viewConditionName="status"
            showAcceptIcon={false}
            showCloseIcon={true}
            acceptDetails={this.acceptOrder}
            rejectDetails={this.rejectOrder}
            acceptConditionName="status"
            acceptConditionValue="1"
            showGenerateBillIcon={true}
            rejectConditionValue="2"
            rejectConditionName="status"
            generateBillConditionName="status"
            generateBillConditionValue="2"
            generateBill={this.openGenerateBillForm}
            showHeadEdit={true}
            rowEdit={this.rowEdit}
            showDownload={false}
            showCancel={false}
          />
          {openDialogBox && (
            <ProductListDialogBox
              columns={[
                {
                  title: "Sr.No.",
                  name: "index",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "center",
                  canSearch: "true",
                },
                {
                  title: "Product Name",
                  name: "name",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "left",
                  canSearch: "true",
                },
                {
                  title: "UOM",
                  name: "stakeHolderUom",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "center",
                  canSearch: "true",
                },
                {
                  title: "Rate",
                  name: "rate",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "right",
                  canSearch: "true",
                },
                {
                  title: "Order Quantity",
                  name: "billQty",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "right",
                  canSearch: "true",
                },
                {
                  title: "Bill Quantity",
                  name: "qty",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "right",
                  canSearch: "true",
                },
                {
                  title: "Free Quantity",
                  name: "freeQty",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "right",
                  canSearch: "true",
                },
                {
                  title: "Discount % On Item",
                  name: "itemDiscPer",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "right",
                  canSearch: "true",
                },
                {
                  title: "Total Amount",
                  name: "total",
                  positionCenter: false,
                  showInscreen: true,
                  alignCenter: "right",
                  canSearch: "true",
                },
                {
                  title: "Action",
                  name: "action",
                  alignCenter: "center",
                  showInscreen: true,
                  canSearch: "true",
                },
              ]}
              open={openDialogBox}
              handleCloses={this.toggle}
              rows={productList}
              rejectOrder={this.rejectOrder}
              acceptOrder={this.acceptOrder}
              comment={comment}
              changeHandler={this.changeHandler}
            />
          )}

          {filterPopUpFlag && (
            <FilterPopUp
              open={filterPopUpFlag}
              handleCloses={this.handleCloses}
              onSearch={this.onSearch}
            />
          )}

          <Grid
            item
            sm={12}
            xs={12}
            md={4}
            lg={4}
            sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
          >
            {tabValue == 0 ? (
              <>
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Accept"
                  fullWidth={false}
                  onClick={() => this.handleAcceptReject(0)}
                />

                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Reject"
                  fullWidth={false}
                  onClick={() => this.handleAcceptReject(1)}
                />
              </>
            ) : (
              <>
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Cancel"
                  fullWidth={false}
                  onClick={() => this.handleAcceptReject(2)}
                />

                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name="Reject"
                  fullWidth={false}
                  onClick={() => this.handleAcceptReject(1)}
                />
              </>
            )}
          </Grid>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  receivedOrderBillList: state.receivedOrderList,
});
const mapDispatchToProps = {
  getReceivedOrderListNew,
  showLoador,
  showNotification,
  getReceivedBillHeaderById,
  getReceivedOrderListByDateUpdated,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ReceivedOrderList);
